const TEMPLATE_HEADERS = [
  'Year',
  'State',
  'Age',
  'IssuerID',
  'IncreaseRate',
  'IsActive',
]

export function downloadSmokerRateTemplate(): void {
  const csv = TEMPLATE_HEADERS.join(',')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'smoker-rate-template.csv'
  link.click()
  URL.revokeObjectURL(url)
}
